<template>
  <div class="contents">
    <div class="contents__inner">
      <v-container id="container-full">
        <p class="title m-2">{{name}}</p>

        <v-layout mt-3 px-5 class="text-xs-center" row wrap>
          <v-flex lg6 sm12 xs12>
            <v-img :src="img" width="407" height="272"></v-img>
          </v-flex>

          <v-flex lg6 sm12 xs12>
            <v-card-text style="word-wrap:break-word; white-space: pre-wrap">{{description}}</v-card-text>
            <v-container>
              <a class="social__icon" target="_blank" :href="twitter">
                <i class="fab fa-twitter-square fa-2x"></i>
              </a>
              <a class="social__icon" target="_blank" :href="instagram">
                <i class="fab fa-instagram fa-2x"></i>
              </a>
              <a class="social__icon" target="_blank" :href="facebook">
                <i class="fab fa-facebook-square fa-2x"></i>
              </a>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { getArtistProfile } from "../functions/artists-function";

export default {
  data() {
    return {
      name: "",
      description: "",
      img: "",
      facebook: "",
      instagram: "",
      twitter: ""
    };
  },
  metaInfo() {
    return {
      title: this.name ,
      meta: [
        { property: "og:title", content: this.name + ' - Profile' },
        { property: "og:site_name", content: this.name + ' - Profile' },
        {
          property: "og:description",
          content:
            this.name
        },
        { property: "og:type", content: "profile" },
        {
          property: "og:url",
          content: "https://islandstatemusic.com/artists/" + this.name
        },
        {
          property: "og:image",
          content: this.img
        }
      ]
    };
  },
  watch: {
    "$route.params.artistName": function() {
      this.getProfile();
    }
  },
  methods: {
    getProfile: async function() {
      const artist = await getArtistProfile(this.$route.params.artistName);
      this.name = artist.name;
      this.description = artist.description;
      this.img = artist.image;
      this.instagram = artist.url_instagram;
      this.twitter = artist.url_twitter;
      this.facebook = artist.url_facebook;
    }
  },
  mounted: function() {
    this.getProfile();
  }
};
</script>

<style lang="scss" scoped>
.contents {
  margin-top: 2em;
  &__inner {
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
  }

  &__items {
    position: relative;
    display: flex;
  }

  &__info {
    margin-left: 2%;
    font-weight: bold;
    font-size: 1em;
  }
}

.image {
  height: 400px;
}

.title {
  font-size: 2.1rem;
  text-transform: uppercase;
  font-family: "discoregular";
  font-weight: normal;
  letter-spacing: 0.3rem;
  margin: 0;
}

.social {
  &__icon {
    .fab {
      color: gray;
    }
    &:nth-of-type(n) {
      margin: 0 0 0 10px;
    }
  }
}

@media screen and (max-width: 480px) {
}
</style>
